var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalNumberOfWorkersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2612 30.3826V27.1179C24.2612 25.3862 23.561 23.7254 22.3147 22.5009C21.0683 21.2763 19.3778 20.5884 17.6152 20.5884H7.64607C5.88342 20.5884 4.19297 21.2763 2.94659 22.5009C1.70021 23.7254 1 25.3862 1 27.1179V30.3826M19.2767 7.52947C19.2767 11.1356 16.3011 14.0589 12.6306 14.0589C8.9601 14.0589 5.98455 11.1356 5.98455 7.52947C5.98455 3.92334 8.9601 1 12.6306 1C16.3011 1 19.2767 3.92334 19.2767 7.52947Z",
    stroke: "#10A242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNumberOfWorkersIcon);
export default __webpack_public_path__ + "static/media/total-number-of-workers-icon.f30eaa314dd5c72fb0c2aebbb9e230fd.svg";
export { ForwardRef as ReactComponent };